export enum PrivacyOptions {
  Allow = 'allow',
  Mask = 'mask',
  Hidden = 'hidden',
  MaskUserInput = 'mask-user-input',
}
